<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/12A74Nt/tc-custom/9781459222458.jpg?1718858322618" alt="This image is the cover for the book Footprints in the Snow, He's a Mystery"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Footprints in the Snow, He's a Mystery
      </h1>
      <p class="bookDescription body article font2">
        <b>A beautiful scientist in the Rocky Mountains is rescued by a WWII-era soldier in the <i>USA Today</i>–bestselling author’s suspenseful time travel romance.</b><br/><br/>Geologist Shana Parisi is enjoying the natural wonders of the Rocky Mountains when a powerful blizzard catches her off guard—and thrusts her back in time to the 1940s. Sergeant Luke Rawlins of the 10th Mountain Division rescues her from danger, but it’s the mesmerizing look in his eyes that captures her heart . . . and forges their destiny.<br/><br/>Luke knows bringing the beautiful Shana back to his cabin poses a threat to his secrets, but a foreign enemy is hot on their trail and Shana’s snowy footprints are all they need to track her down. Once entrenched in his world, Luke urges her to remain silent about what she saw. Because the alternative could be deadly. . . .
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Cassie Miles
      </h2>
      
      <p class="authorDescription body article">USA TODAY bestselling author Cassie Miles lives in Colorado. After raising two daughters and cooking tons of macaroni and cheese for her family, Cassie is trying to be more adventurous in her culinary efforts. She's discovered that almost anything tastes better with wine. When she's not plotting Harlequin Intrigue books, Cassie likes to hang out at the Denver Botanical Gardens near her high-rise home.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?8e284076